import RaikoGridOneColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridOneColumn";
import RaikoMaterialOutlinedInput from "../../raikoComponents/raikoInputs/RaikoMaterialOutlinedInput";
import {useEffect, useState} from "react";
import {css} from "@emotion/css";
import {RaikoDivider} from "../../raikoComponents/raikoDivider/RaikoDivider";
import RaikoMultiSelectTable from "../../raikoComponents/raikoMultiSelectTable/RaikoMultiSelectTable";
import ButtonPrimaryRaiko from "../../raikoComponents/raikoButtons/ButtonPrimaryRaiko";
import {ManagerAccessLevelService} from "../../serverService/managerAccessLevelService/ManagerAccessLevelService";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {LoadingHelper} from "../../util/LoadingHelper";

export const ManagerAccessLevelDetail = ({accessSelectedItemId = -1, changeNeedRefresh}) => {

    let page = 0
    const size = 10

    const service = new ManagerAccessLevelService()

    const snackbarDispatch = useSnackbarDispatcher();
    const snackbar = new SnackbarHelper(snackbarDispatch)

    const loadingDispatcher = useLoadingDispatcher()
    const loading = new LoadingHelper(loadingDispatcher)

    const [englishName, setEnglishName] = useState("");
    const [name, setName] = useState("");

    const [pageCount, setPageCount] = useState(2);
    const [accessList, setAccessList] = useState([]);
    const [accessSelectedItems, setAccessSelectedItems] = useState([]);
    const [accessTableLoadingState, setAccessTableLoadingState] = useState(false);


    useEffect(() => {
        if (service) {
            getPermissionsListFromServer()
        }
    }, [])

    useEffect(() => {
        if (accessSelectedItemId && accessSelectedItemId !== -1) {
            getRoleInfoFromServer()
        }
    }, [accessSelectedItemId])

    function getRoleInfoFromServer() {
        loading.show()
        service.getRoleInfo(accessSelectedItemId)
            .then(response => {
                setName(response.name)
                setAccessSelectedItems(response.permissions)
                loading.hide()
            }).catch(reason => {
            snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage())
            loading.hide()
        })
    }

    function prepareRoleListRow(number, id, name) {
        return {
            number,
            id,
            name
        }
    }

    function getPermissionsListFromServer() {
        // setAccessTableLoadingState(true)
        service.getPermissionsList(page, size)
            .then(response => {

                const _list = []
                response.data.map((item, index) => {
                    _list.push(
                        prepareRoleListRow(
                            (page * size) + index + 1,
                            item.id,
                            item.name
                        )
                    )
                })

                setAccessList(_list)

                setPageCount(response.totalPage)
                setAccessTableLoadingState(false)

            }).catch(reason => {
            setAccessTableLoadingState(false)
            snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage())
        })
    }

    function handleChangePagination(newPage) {
        page = newPage
        getPermissionsListFromServer()
    }

    function handleChangeAccess() {
        if (accessSelectedItemId && accessSelectedItemId.length > 0) {
            doUpdateExistingAccess()
        } else {
            doAddNewAccess()
        }
    }

    function clearFields() {
        setName("")
        setAccessSelectedItems([])
    }

    function doAddNewAccess() {
        if (checkFields()) {
            loading.show()
            service.addNewRole(name, accessSelectedItems)
                .then(response => {
                    changeNeedRefresh(true)
                    snackbar.showSuccessMessage("سطح دسترسی جدید با موفقیت افزوده شد!")
                    clearFields()
                    loading.hide()
                }).catch(reason => {
                snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage())
                loading.hide()
            })
        }
    }

    function checkFields() {
        let state = false
        let message = ""

        if (name.length === 0) {
            message = "لطفا نام دسترسی را وارد نمایید!"
        } else if (accessSelectedItems.length === 0) {
            message = "لطفا دسترسی های مورد نظر را انتخاب نمایید!"
        } else {
            state = true
        }

        snackbar.showErrorMessage(message)

        return state


    }

    function doUpdateExistingAccess() {
        if (checkFields()) {
            loading.show()
            service.updateRoleInfo(
                accessSelectedItemId,
                name,
                accessSelectedItems
            ).then(response => {
                changeNeedRefresh(true)
                snackbar.showSuccessMessage("بروزرسانی با موفقیت انجام شد!")
                loading.hide()
            }).catch(reason => {
                snackbar.showErrorMessage(new ServerErrorHandler(reason).getMessage())
                loading.hide()
            })

        }
    }

    return (
        <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem`}>
            <RaikoGridOneColumn>
                <RaikoMaterialOutlinedInput value={name} setValue={setName} labelText={"عنوان"}/>
            </RaikoGridOneColumn>

            <RaikoDivider/>

            <RaikoMultiSelectTable
                pageCount={pageCount}
                setSelectedItems={setAccessSelectedItems}
                handleChangePagination={handleChangePagination}
                tableData={accessList}
                selectedItems={accessSelectedItems}
                tableHeader={accessTableHeader}
                tableLoadingState={accessTableLoadingState}
            />
            <div className={css`display: flex;
              justify-content: end;`}>
                <ButtonPrimaryRaiko
                    label={accessSelectedItemId && accessSelectedItemId.length > 0 ? "بروزرسانی" : "افزودن"}
                    onClick={handleChangeAccess}
                />
            </div>
        </RaikoGridOneColumn>
    )
}


const accessTableHeader = [
    {
        id: "number",
        label: "#"
    },
    {
        id: "name",
        label: "عنوان"
    },
    {
        id: "access",
        label: "سطح دسترسی"
    }
]